import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "../components/Reveal";
import { SERVICES } from "../lib/data";

const SPANS = [
  "lg:col-span-4 h-[26rem]",
  "lg:col-span-2 h-[26rem]",
  "lg:col-span-2 h-80",
  "lg:col-span-2 h-80",
  "lg:col-span-2 h-80",
  "lg:col-span-6 h-72",
];

export default function Services() {
  return (
    <main className="pt-40 pb-32" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-6">
        <FadeUp>
          <p className="font-mono-tech text-xs tracking-[0.3em] text-lime-400 uppercase mb-4">Services</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl text-zinc-50 leading-tight max-w-4xl mb-6">
            Everything your property needs, <span className="italic text-lime-300">under one roof.</span>
          </h1>
          <p className="text-zinc-400 max-w-2xl text-base md:text-lg font-light leading-relaxed mb-20">
            From planned maintenance contracts to one-off weekend fixes — clear quotes, tidy work, and a team you'll actually want back.
          </p>
        </FadeUp>

        <div className="grid gap-6 lg:grid-cols-6">
          {SERVICES.map((s, i) => (
            <FadeUp key={s.id} delay={0.05 * i} className={SPANS[i]}>
              <article
                data-testid={`service-card-${s.id}`}
                className="group relative h-full w-full rounded-2xl overflow-hidden border border-white/5 transition-colors duration-500 hover:border-lime-400/40"
              >
                <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-black/10" />
                <div className="absolute top-6 left-6 font-mono-tech text-xs text-lime-300/90 tracking-[0.2em]">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="absolute bottom-0 p-8 transition-transform duration-500 group-hover:-translate-y-1.5">
                  <h2 className="font-display text-2xl lg:text-3xl text-zinc-50 mb-3">{s.title}</h2>
                  <p className="text-sm text-zinc-300/90 leading-relaxed max-w-lg">{s.description}</p>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>

        <FadeUp className="mt-20 flex flex-wrap items-center gap-6">
          <p className="text-zinc-400 text-sm">Not sure which service fits? Describe the job and we'll point you the right way.</p>
          <Link
            to="/about#booking"
            data-testid="services-book-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-lime-400 text-black font-semibold px-8 py-4 transition-all duration-300 hover:bg-lime-300 hover:-translate-y-1"
          >
            Get a free quote
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </div>
    </main>
  );
}
